export interface IGlobalContext {
	PageName: INamePageContext,
	PageWelcome: IWellcomePageContext
}

export interface IPageContext {
	name: string;
	context: INamePageContext | IWellcomePageContext; // agregar pages a medida que se creen nuevas
}

export interface INamePageContext {
	name?: string;
}

export interface IWellcomePageContext {
	evaluationProfile?: eEvaluationProfile;
}

export enum eEvaluationProfile {
	invest,
	refinancing
}

export enum ePageNames {
	namePage = 'namePage',
	wellcomePage = 'wellcomePage'
}

// eslint-disable-next-line no-unused-vars 
export enum STATUS {
	// eslint-disable-next-line no-unused-vars
	idle,
	// eslint-disable-next-line no-unused-vars
	pending,
	// eslint-disable-next-line no-unused-vars
	error,
	// eslint-disable-next-line no-unused-vars
	init
}

export enum ePropertyCondition {
	new = 1,
	used = 2
}

export enum eOperationFamily {
	ventaUsado = 1,
	ventaNuevo = 2,
	arriendo = 3,
}
export enum eLeadType {
	quote = 1,
	contact = 2
}
export enum eOriginId {
	listaSeoQuote = 39,
	listaSeoContact = 40,
	listaSeoItau= 42,
}

export const ORIGIN_BY_ID: Record<number, string> = {
	0: '--sin origen--',
	1: 'CBR_Transacciones',
	2: 'Tesoreria',
	3: 'SII',
	4: 'ElInmobiliario',
	5: 'Servel',
	6: 'Google',
	7: 'TocToc WEB',
	8: 'TocToc MOVIL',
	9: 'TocToc MOVIL ANDROID',
	10: 'TocToc MOVIL IPHONE',
	11: 'MapCity',
	12: 'Migracion',
	13: 'TocToc',
	14: 'TocTocWebCampañaImetrics',
	15: 'IntegracionCorredora',
	16: 'ZoomInmobiliario',
	17: 'Facebook',
	18: 'Catastro2013',
	19: 'Catastro2014',
	20: 'Platanus',
	21: 'Infoinmobiliario',
	22: 'Tesoreria ApiInmobiliario',
	23: 'Catastro2016',
	24: 'AddInmobiliario',
	25: 'AddCorredor',
	26: 'MiniSitio Scotiabank',
	27: 'MiniSitio Quiroz & Droguett',
	28: 'MiniSitio Santander',
	29: 'Bancapropiedades - Santander',
	30: 'Catastro2017Semestre2',
	31: 'Catastro2018Semestre1',
	32: 'Scraper SII 2018 sin aseo municipal',
	33: 'Integración  AWS',
	34: 'WhatsApp',
	35: 'Crédito hipotecario',
	36: 'Cotización express crédito hipotecario',
	37: 'Cotización automática',
	38: 'Contacto automático',
	39: 'Lista SEO cotización',
	40: 'Lista SEO contacto',
	41: 'Ficha Itaú cotización',
	42: 'Lista SEO Itaú',
}
